import newShop from '../newShop.js';
import "./Payment";
import PaymentType from "./paymentType";
import {isEnabled} from "@nuskin/ns-feature-flags";
import {AccertifyFraudService} from "../shop.js";
import {getCachedConfiguration} from '@nuskin/configuration-sdk';
export default {
    mapSAPPaymentToPayment,
    populatePayment
};

/**
 *
 * @param {SAPPayment} payment - Payment from SAP Sales Order Detail
 * @returns {nuskin.newShop.Payment}
 */
function mapSAPPaymentToPayment(payment)
{
    let data = {
        bePaymentTypeId: fromCustom(payment.Custom, "PROFILE_ID")
    };

    if (payment.BillingAddress) {
        data = Object.assign({}, data, {
            address1: payment.BillingAddress.address,
            address2: fromCustom(payment.Custom, "ZZBILLING_ADDR2", "CCBIL"),
            city: payment.BillingAddress.city,
            district: payment.BillingAddress.district,
            region: payment.BillingAddress.state,
            countryCode: payment.BillingAddress.country,
            email: fromCustom(payment.Custom, "ZZBILLING_EMAIL", "CCBIL"),
            phone: fromCustom(payment.Custom, "ZZBILLING_PHONE", "CCBIL")
        });
    }

    switch (payment.type) {
        case "CCARD":
            data = Object.assign({}, data, {
                paymentTypeId: PaymentType[payment.CreditCard.Type],
                paymentTypeDescription: payment.CreditCard.Type,
                paymentName: payment.CreditCard.Name,
                paymentNumber: payment.CreditCard.CardNumber,
                expMonth: payment.CreditCard.ExpirationMonth,
                expYear: toTwoDigitYear(payment.CreditCard.ExpirationYear)
            });
            break;
        case "DIRECTDEBIT":
            data = Object.assign({}, data, {
                paymentName: payment.Bank.AccountHolderName,
                paymentNumber: payment.Bank.IBAN,
                bankCountry: payment.Bank.BankCountry
            });
            break;
        case "COMPANYCREDIT":
        case "WIRE":
            break;
        default:
            throw new Error(`Payment class ${payment.type} could not be converted`);
    }

    return new newShop.Payment(data);
}

/**
 * Converts a 2- or 4-digit year to a 2-digit year.
 * @param {string} year
 */
function toTwoDigitYear(year) {
    return /^\d{2}$/.test(year) ? year : year.substring(2);
}

/**
 * Finds and returns the Value of the matching Custom Field.
 * @param {CustomField[]} customFields List of Custom Fields
 * @param {string} key Custom Field key
 * @param {string} [type] (optional) Custom Field type
 * @returns {string | undefined} Value of Custom Field, or undefined if no match found
 */
function fromCustom(customFields, key, type) {
    return (
        customFields
            .filter(c => type ? c.Type === type : true)
            .find(c => c.Key === key) || {}
    ).Value;
}

function populatePayment(order, salesOrder) {
    const cx8_380_accertify = isEnabled('cx8_380_accertify');
    if (order.selectedPayment) {
        salesOrder.Payment = [];

        // Creating a payment to be sent
        // According to Mike, the Custom expects a String type, so convert paymentTypeId to a string
        let paymentToSend = {
            type: order.paymentClass,
            Currency: order.currencyCode,
            action: "ADD",
            Custom: [{
                Key: "PAYMENT_TYPE",
                Value: order.selectedPayment.paymentTypeId.toString()
            }]
        };

        // Add amount to the paymentToSend if authorized externally.
        if (order.selectedPayment.paymentSecurityNumber){
            paymentToSend.amount = order.orderTotals.grandTotal;
        }

        switch (order.paymentClass) {
            case "CCARD":
                paymentToSend.CreditCard = {
                    "TransactionType":{
                        "value":null,
                        "PaymentPeriod":0
                    }
                };
                switch (order.selectedPayment.paymentTypeId) {
                    case PaymentType.DBS:
                    case PaymentType.UOB:
                    case PaymentType.MBB:
                    case PaymentType.PBB:
                    case PaymentType.CIMB:
                    case PaymentType.KBANK:
                    case PaymentType.BDO:
                    case PaymentType.APVN:
                    case PaymentType.CITI:
                    case PaymentType.HSBC:
                    case PaymentType.ALIP:
                        paymentToSend.Bank = { BankKey: order.paymentOfsId };
                        break;

                    case PaymentType.BCA: // SPEED order ID installment
                        paymentToSend.CreditCard.CardNumber = order.selectedPayment.ccToken || order.selectedPayment.paymentNumber;
                        paymentToSend.CreditCard.AuthorizationCode =
                            order.selectedPayment.paymentSecurityNumber
                                ? order.selectedPayment.paymentSecurityNumber
                                : "";
                        paymentToSend.CreditCard.Name =
                            order.selectedPayment.paymentName
                                ? order.selectedPayment.paymentName
                                : order.selectedPayment.billingName;
                        paymentToSend.CreditCard.ExpirationMonth = order.selectedPayment.expMonth;
                        paymentToSend.CreditCard.ExpirationYear = order.selectedPayment.expYear;
                        paymentToSend.CreditCard.VerificationCode = order.paymentSecurityNumber;
                        paymentToSend.CreditCard.PostalCode = order.selectedPayment.paymentPostalCode;
                        paymentToSend.CreditCard.EncryptedCardNumber =
                            (order.selectedPayment.sapPaymentObject && order.selectedPayment.sapPaymentObject.CreditCard)
                                ? order.selectedPayment.sapPaymentObject.CreditCard.EncryptedCardNumber
                                : "";
                        paymentToSend.CreditCard.TrackOne = "";
                        paymentToSend.Bank = { BankKey: order.paymentOfsId };
                        break;

                    default:
                        paymentToSend.CreditCard.Type = order.paymentOfsId;
                        paymentToSend.CreditCard.CardNumber = order.selectedPayment.ccToken || order.selectedPayment.paymentNumber;
                        paymentToSend.CreditCard.AuthorizationCode =
                            order.selectedPayment.paymentSecurityNumber ? order.selectedPayment.paymentSecurityNumber : "";
                        paymentToSend.CreditCard.Name =
                            order.selectedPayment.paymentName ? order.selectedPayment.paymentName : order.selectedPayment.billingName;
                        paymentToSend.CreditCard.ExpirationMonth = order.selectedPayment.expMonth;
                        paymentToSend.CreditCard.ExpirationYear = order.selectedPayment.expYear;
                        paymentToSend.CreditCard.VerificationCode = order.paymentSecurityNumber;
                        paymentToSend.CreditCard.PostalCode = order.selectedPayment.paymentPostalCode;
                        paymentToSend.CreditCard.EncryptedCardNumber =
                            (order.selectedPayment.sapPaymentObject && order.selectedPayment.sapPaymentObject.CreditCard)
                                ? order.selectedPayment.sapPaymentObject.CreditCard.EncryptedCardNumber
                                : "";
                        paymentToSend.CreditCard.TrackOne = "";

                        if(cx8_380_accertify) {
                            if (AccertifyFraudService.accertifyInMarketConfig(getCachedConfiguration('Checkout'))) {
                                if (AccertifyFraudService.getAccertifyReceivedTransactionID() === true) {
                                    paymentToSend.Custom.push(AccertifyFraudService.retrieveAccertifyTransactionIdCustomPaymentField());
                                }
                            }
                        }
                        break;
                }
                break;
            case "DIRECTDEBIT":
                paymentToSend.Bank = {
                    BankCountry: order.selectedPayment.bankCountry,
                    AccountHolderName: order.selectedPayment.paymentName,
                    IBAN: order.selectedPayment.paymentNumber.replace(/\s/g, '')
                };
                paymentToSend.Custom.push({
                    Type:"SEPA",
                    Key:"FLAG_ELECTRONIC",
                    Value:order.selectedPayment.mandateType == 'electronic' ? 'X' : ''
                });
                paymentToSend.amount = 0;
                break;
            case "WIRE":
                paymentToSend.Custom.push({
                    Type:"CARD_TYPE",
                    Key:"WIRE",
                    Value:order.paymentOfsId
                });
                paymentToSend.amount = 0;
                break;
            case "COMPANYCREDIT":
                // we cannot put amount for companycredit
                paymentToSend.amount = 0;
                break;
            default:
        }

        try {
            if (order.selectedPayment && order.selectedPayment.getUseInstallments && order.selectedPayment.getUseInstallments()) {
                paymentToSend.CreditCard.Installments = order.selectedPayment.getInstallmentSelectedNumber();
                paymentToSend.CreditCard.TransactionType.value = "INSTALLMENT";
                paymentToSend.CreditCard.TransactionType.PaymentPeriod = order.selectedPayment.getInstallmentSelectedNumber();
            }
        } catch(err) {
            console.error(err);
        }

        if (!order.selectedPayment.unsavedPayment && order.selectedPayment.paymentNumber !== null) {
            paymentToSend.Custom.push({
                Key:"PROFILE_ID",
                Value:order.selectedPayment.bePaymentTypeId
            });
        }

        if (order.selectedPayment.email) {
            paymentToSend.Custom.push({
                Key:"ZZBILLING_EMAIL",
                Value: order.selectedPayment.email,
                Type: "CCBIL"
            })
        }

        if (order.selectedPayment.phone) {
            paymentToSend.Custom.push({
                Key:"ZZBILLING_PHONE",
                Value: order.selectedPayment.phone,
                Type: "CCBIL"
            })
        }

        if (order.selectedPayment.address2 && order.countryCode !== "US") {
            paymentToSend.Custom.push({
                Key:"ZZBILLING_ADDR2",
                Value: order.selectedPayment.address2,
                Type: "CCBIL"
            })
        }

        if (order.selectedPayment.address1) {
            let addr = order.selectedPayment.address1;
            if (order.countryCode === "US") {
                addr = (order.selectedPayment.address2) ? addr + " " + order.selectedPayment.address2 : addr;
            }
            paymentToSend.BillingAddress = {
                "address": addr,
                "city":order.selectedPayment.city,
                "state":order.selectedPayment.region
            };
            if (order.selectedPayment.countryCode) {
                paymentToSend.BillingAddress.country = order.selectedPayment.countryCode;
            }
        }

        salesOrder.Payment.push(paymentToSend);
    }
}

/**
 * Object representing the payment applied to an order.
 * @typedef SAPPayment
 * @property {string} [id] - Payment ID.
 * @property {string} type - Payment type: "CASH", "CCARD", "COMPANYCREDIT", "WIRE", "DIRECTDEBIT", "PAYD".
 * @property {number} amount - Payment amount.
 * @property {string} action - Action to take regarding this payment: "ADD", "UPDATE", "DELETE". Applicable only to requests.
 * @property {string} Currency - Currency code for the payment amount.
 * @property {string} AuthorizationStatus - Payment authorization status.
 * @property {Messages} DeclinedMessage - User message to show if this payment is declined.
 * @property {CreditCard} CreditCard - Credit card information associated with this payment.
 * @property {Bank} Bank - Bank information associated with this payment.
 * @property {Array<CustomField>} Custom - Custom data fields applied to this payment information.
 * @property {Array<Verification>} Verification -
 * @property {BillingAddress} BillingAddress - Billing address associated with this payment.
 * @property {Array<PaymentMessage>} Messages - List of server messages regarding this payment.
 * @property {Authorization} AdditionalAuthorization -
 */

/**
 * Object representing a credit card.
 * @typedef CreditCard
 * @property {string} Type - Credit card type.
 * @property {string} CardNumber - Credit card number. Obfuscated if this is a saved card.
 * @property {string} AuthorizationCode - Authorization code for this credit card.
 * @property {string} Name - Name on this credit card.
 * @property {string} ExpirationMonth - Two-digit numeric string representing the expiration month. Example: January would be rendered as "01".
 * @property {string} ExpirationYear - Four-digit numeric string representing the expiration year. Example: 2023 would be rendered as "2023".
 * @property {string} PostalCode - Billing postal code for this credit card.
 * @property {string} VerificationCode - Verification code for this credit card, if applicable.
 * @property {string} [EncryptedCardNumber] - Credit card number in encrypted form. Applicable only if this is a saved card.
 * @property {string} TrackOne -
 * @property {string} Installments -
 * @property {TransactionType} TransactionType -
 */

/**
 * Object representing the bank associated with a payment.
 * @typedef Bank
 * @property {string} BankCountry - Two-letter country code of bank country
 * @property {string} BankKey -
 * @property {string} BankControlKey -
 * @property {string} BankAccount -
 * @property {string} BankName -
 * @property {string} BankBranch -
 * @property {string} AccountHolderName - Name of bank account holder
 * @property {string} IBAN - International Bank Account Number
 * @property {string} Type -
 */

/**
 *
 * @typedef Verification
 * @property {string} Key -
 * @property {string} Value -
 * @property {string} Provider -
 */

/**
 *
 * @typedef BillingAddress
 * @property {string} address - Billing street address
 * @property {string} district - Billing district/county
 * @property {string} city - Billing city
 * @property {string} country - Billing country (two-letter country code)
 * @property {string} state - Billing state/region
 */

/**
 *
 * @typedef Authorization
 * @property {number} AuthTimeStamp -
 * @property {string} AuthorizationReference -
 * @property {string} TransactionReference -
 * @property {string} MerchantID -
 * @property {string} Result -
 * @property {string} ResultText -
 * @property {string} ResultCode -
 * @property {string} ResultACI -
 * @property {string} ResultCVV -
 * @property {string} DelegoResponseCode -
 * @property {string} DelegoReference -
 */

/**
 * Object representing a custom data field used in communication with Nu Skin Shop APIs.
 * This is used to pass a data value from client to server or vice-versa, where the value
 * in question doesn't fit into the existing API data fields.
 * @typedef CustomField
 * @property {string} Key - Custom field key name.
 * @property {string} Value - Custom field value.
 * @property {string} Type - Custom field type.
 */
